import React, { useEffect } from  'react'
import Footer from '../componets/General/Footer'
import NavBar from '../componets/General/NavBar'
import JuegosList from '../componets/juegos/JuegosList'

const Minijuegos = () =>{
    useEffect(()=>{
        window.scrollTo(0,0);
    },[])
    return (
        <>
        <NavBar/>
        <JuegosList/>   
        <Footer/>
        </>
    )
}

export default Minijuegos